import React, { useEffect, useContext } from "react";
import Formulario from "../../components/Formulario/NuevoContenedor";

import { editarContenedor, obtenerContenedor } from "../../redux/actions/contenedor";
import { useDispatch, useSelector } from "react-redux";

const Editar = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { contenedor, editOk } = state.contenedor;

  useEffect(() => {
    // console.log(props.match.params.id);
    dispatch(obtenerContenedor(props?.match?.params?.id));
  }, []);

  useEffect(() => {
   
    console.log(editOk);
    if (editOk) {
      props.history.push("/contenedores");
    }
  }, [editOk]);

  const edicion = (contenedor) => {
    // editar producto;
    dispatch(editarContenedor(contenedor));
  };

  if (!contenedor) return <p>Cargando ...</p>;
  return (
    <div>
      <h1>Editar Contenedor</h1>
      <Formulario contenedor={contenedor} editar={true} editarContenedor={edicion} />
    </div>
  );
};

export default Editar;
